module.exports = __webpack_public_path__ + "static/media/whyUs01.4fd69975.png";